<template>
<div class="product-tax-code-entry">
	<div class="product_name">
		<img v-if="taxCode.imageUrl" :src="taxCode.imageUrl" />
		<img v-else :src="require('@/assets/img/placeholder-img.svg')" />
		<span>
			{{taxCode.productName}}
		</span>
	</div>
	<div class="flex-none arrow" >
		<img :src="require('@/assets/img/arrow-top.svg')" />
	</div>
	<div class="tax_code">
		<input-field class="flex" v-model="taxCode.taxCode" small flat placeholder="Tax code"
		             @input="change()" @change="change()"  />
		<quick-actions-btn :items="[`Change`]" @menuClick="popupOpen=true" />

		<portal to="popup">
			<tax-codes-popup v-if="popupOpen" @change="selectItem"
			                 :app-id="appId" :funnel-id="funnelId" :api-key="apiKey" @close="popupOpen=false" />
		</portal>
	</div>
</div>
</template>

<script>
import SelectField from "@/components/base/select-field";
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import TaxCodesPopup from "@/views/funnels/apps/funnel-apps/taxjar/tax-codes-popup";
export default {
	name: "product-tax-code-entry", components: {TaxCodesPopup, QuickActionsBtn, VButton, InputField, SelectField},
	props:['appConfig', "taxCode", 'appId', 'funnelId', 'apiKey'],

	data(){
		return {
			// value: this.taxCode,
			popupOpen: false,
		}
	},
	methods:{
		change() {
			this.$emit('change', this.taxCode, this.value)
		},
		selectItem(taxCode) {
			this.taxCode.taxCode = taxCode.product_tax_code;
			this.popupOpen = false;
			this.change();
		}
	},
	created() {
		// this.value = this.taxCode
	}
}
</script>

<style lang="scss">

</style>
<style lang="scss" scoped>
.product-tax-code-entry {
	display: flex;
	flex-direction: row;
	flex: 1;
	align-items: center;
	border-radius: 6px;
	padding: 10px;
	margin-bottom: 10px;
	background: $light-blue;

	.product_name {
		width: 60%;
		display: flex;
		flex-direction: row;
		align-items: center;
		> img {
			width: 30px;
			height: 30px;
			object-fit: scale-down;
			border: 1px solid #c8c8c9;
			background: #efefef;
			border-radius: 2px;
			margin-right: 6px;
		}
		span {
			font-weight: 600;
			font-size: 14px;
		}
	}
	.arrow {
		img {
			margin: 0 10px;
			width: 16px;
			height: 16px;
		}
	}
	.tax_code {
		width: 40%;
		display: flex;
		flex-direction: row;
		.quick-actions-btn {
			margin-left: 5px;
		}
	}
}
</style>
